import Load from 'components/Load';
import React from 'react';
import { Route } from 'react-router-dom';
import basePath from 'utils/basePath';

const AsyncRequestResetPasswordContainer = Load(
  () =>
    import(
      /* webpackChunkName: "password-reset" */ './containers/RequestResetPasswordContainer'
    ),
  {},
  true,
);
const AsyncResetPasswordContainer = Load(
  () =>
    import(
      /* webpackChunkName: "password-reset" */ './containers/ResetPasswordContainer'
    ),
  {},
  true,
);
const AsyncChangePasswordContainer = Load(
  () =>
    import(
      /* webpackChunkName: "change-password" */ './containers/ChangePasswordContainer'
    ),
  {},
  true,
);

const PasswordRoutes = [
  <Route
    key={'password'}
    path={`${basePath}/password`}
    element={<AsyncChangePasswordContainer />}
  />,
  <Route
    key={'password.reset.token'}
    path={`${basePath}/reset/:token`}
    element={<AsyncResetPasswordContainer />}
  />,
  <Route
    key={'password.reset'}
    path={`${basePath}/reset`}
    element={<AsyncRequestResetPasswordContainer />}
  />,
];

export default PasswordRoutes;
